import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProposalDetailsComponent } from './proposal-details.component';

const routes: Routes = [{ path: '', component: ProposalDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProposalDetailsRoutingModule {}
